// i18n keys of the multi-tenant work package "ctrlplane" (en / zh / th). ⛔ Fill all three: an empty th value falls back to English.
// Sign-in page titles (brand from GET /api/public/brand) and the client portal address (Workspace card, Client Portal admin).
export const en: Record<string, string> = {
  ctrl_system_title: '{{brand}} System',
  ctrl_system_generic: 'Management System',
  ctrl_portal_title: '{{brand}} Client Portal',
  ctrl_portal_generic: 'Client Portal',
  ctrl_logo_alt: 'Logo',
  ctrl_portal_base: 'Client portal address',
  ctrl_portal_base_hint: 'Where clients sign in to the invoicing portal; printed in every portal account message. Empty = the public base URL + /portal.',
  ctrl_portal_base_env: 'Set by PORTAL_BASE_URL in the server environment.',
  ctrl_portal_base_in_use: 'In use: {{url}}',
  ctrl_portal_base_default: 'In use (default): {{url}}',
  ctrl_portal_base_unset: 'Not set: clients cannot be given a sign-in address. Set this or the public base URL.',
  ctrl_portal_cors_gap: 'The server does not allow {{origin}} (CORS_ORIGIN in server/.env): sign-ins from the portal will be refused until it is added.',
  ctrl_portal_unset_admin: 'The client portal address is not set (Admin → Companies → Workspace).',
};
export const zh: Record<string, string> = {
  ctrl_system_title: '{{brand}} 系统',
  ctrl_system_generic: '管理系统',
  ctrl_portal_title: '{{brand}} 客户门户',
  ctrl_portal_generic: '客户门户',
  ctrl_logo_alt: '标志',
  ctrl_portal_base: '客户门户地址',
  ctrl_portal_base_hint: '客户登录开票门户的地址,所有门户开户消息都会印出它。留空 = 公共网址 + /portal。',
  ctrl_portal_base_env: '由服务器环境变量 PORTAL_BASE_URL 指定。',
  ctrl_portal_base_in_use: '当前使用:{{url}}',
  ctrl_portal_base_default: '当前使用(默认):{{url}}',
  ctrl_portal_base_unset: '未设置:无法告诉客户去哪里登录。请填写此项或公共网址。',
  ctrl_portal_cors_gap: '服务器未放行 {{origin}}(server/.env 的 CORS_ORIGIN):补上之前,门户的登录会被浏览器拒绝。',
  ctrl_portal_unset_admin: '客户门户地址未设置(管理 → 公司 → 工作区)。',
};
export const th: Record<string, string> = {
  ctrl_system_title: 'ระบบ {{brand}}',
  ctrl_system_generic: 'ระบบบริหารจัดการ',
  ctrl_portal_title: 'พอร์ทัลลูกค้า {{brand}}',
  ctrl_portal_generic: 'พอร์ทัลลูกค้า',
  ctrl_logo_alt: 'โลโก้',
  ctrl_portal_base: 'ที่อยู่พอร์ทัลลูกค้า',
  ctrl_portal_base_hint: 'ที่อยู่ที่ลูกค้าใช้เข้าสู่ระบบพอร์ทัลออกเอกสาร ซึ่งจะพิมพ์อยู่ในทุกข้อความแจ้งบัญชีพอร์ทัล เว้นว่าง = URL สาธารณะ + /portal',
  ctrl_portal_base_env: 'กำหนดโดย PORTAL_BASE_URL ในสภาพแวดล้อมของเซิร์ฟเวอร์',
  ctrl_portal_base_in_use: 'ที่ใช้อยู่: {{url}}',
  ctrl_portal_base_default: 'ที่ใช้อยู่ (ค่าเริ่มต้น): {{url}}',
  ctrl_portal_base_unset: 'ยังไม่ได้ตั้งค่า: ไม่สามารถแจ้งที่อยู่เข้าสู่ระบบให้ลูกค้าได้ กรุณาตั้งค่านี้หรือ URL สาธารณะ',
  ctrl_portal_cors_gap: 'เซิร์ฟเวอร์ยังไม่อนุญาต {{origin}} (CORS_ORIGIN ใน server/.env) การเข้าสู่ระบบจากพอร์ทัลจะถูกเบราว์เซอร์ปฏิเสธจนกว่าจะเพิ่ม',
  ctrl_portal_unset_admin: 'ยังไม่ได้ตั้งค่าที่อยู่พอร์ทัลลูกค้า (ผู้ดูแลระบบ → บริษัท → พื้นที่ทำงาน)',
};
